
// Rough estimates based on Irish tax system
export function estimateDeductions(grossIncome: number) {
  // Income Tax (roughly 20% on first €40,000, 40% thereafter)
  const standardRate = 0.20;
  const higherRate = 0.40;
  const standardBand = 40000;
  
  let incomeTax = 0;
  if (grossIncome <= standardBand) {
    incomeTax = grossIncome * standardRate;
  } else {
    incomeTax = (standardBand * standardRate) + 
                ((grossIncome - standardBand) * higherRate);
  }

  // USC (Universal Social Charge) - simplified bands
  let usc = 0;
  if (grossIncome > 13000) { // USC threshold
    if (grossIncome <= 12012) {
      usc = grossIncome * 0.005;
    } else if (grossIncome <= 22920) {
      usc = (12012 * 0.005) + ((grossIncome - 12012) * 0.02);
    } else if (grossIncome <= 70044) {
      usc = (12012 * 0.005) + 
            ((22920 - 12012) * 0.02) + 
            ((grossIncome - 22920) * 0.04);
    } else {
      usc = (12012 * 0.005) + 
            ((22920 - 12012) * 0.02) + 
            ((70044 - 22920) * 0.04) + 
            ((grossIncome - 70044) * 0.08);
    }
  }

  // PRSI (generally 4% for employees)
  const prsi = grossIncome > 18304 ? grossIncome * 0.04 : 0;

  // Property Tax (rough estimate based on average house value)
  const propertyTax = 400; // Average annual LPT

  return {
    incomeTax: Math.round(incomeTax),
    usc: Math.round(usc),
    prsi: Math.round(prsi),
    propertyTax,
    homeLoanInterest: 0, // Can't estimate, depends on individual circumstances
    maintenancePayments: 0, // Can't estimate, depends on individual circumstances
    healthExpenses: Math.round(grossIncome * 0.02) // Rough estimate of 2% of income
  };
}
